<template>
  <div>

    <el-row style="background-color: white; border-bottom: 2px solid #0c2c4e;">
      <el-col :span="2">
        <!-- <img src="../../assets/home/obia.jpg" width="90" height="45" style="margin-top: 7px;"> -->
        <img src="../../assets/home/logo1.png" @click="toHome" width="45" height="45" style="margin-top: 5px;">
      </el-col>

      <el-col :span="13">
        <div class="top-menu" style="float:left;">
          <el-menu
            mode="horizontal"
            :default-active="activeIndex"
            :router="true"
            @select="handleSelect"
            >
            <el-menu-item index="/home">Home</el-menu-item>
            <el-menu-item index="/browse">Browse</el-menu-item>

            <!-- <el-menu-item index="/request-new">New a Request</el-menu-item> -->
            <!-- <el-menu-item index="/request-view">View all requests</el-menu-item> -->
            <!-- <el-menu-item index="/submit-requests">Submitted Requests</el-menu-item> -->
            <!-- <el-menu-item index="/receive-requests">Received Requests</el-menu-item> -->

            <el-menu-item v-if="!isLogin" index="/submit">Submit</el-menu-item>
            <el-submenu v-if="isLogin" index="submit">
              <template slot="title">Submit</template>
              <el-menu-item index="/submit">Submit</el-menu-item>
              <el-menu-item index="/submit/my-submissions">My Submissions</el-menu-item>
            </el-submenu>

            <el-menu-item index="/statistics">Statistics</el-menu-item>

            <el-menu-item v-if="!isLogin" index="/request">Request</el-menu-item>
            <el-submenu v-if="isLogin" index="request">
              <template slot="title">Request</template>
              <el-menu-item index="/request">Request</el-menu-item>
              <el-menu-item index="/request/my-requests">My Requests</el-menu-item>
            </el-submenu>

            <el-submenu index="documentation">
              <template slot="title">Documentation</template>
              <el-menu-item index="/obia">OBIA</el-menu-item>
              <el-menu-item index="/de-identification">De-identification</el-menu-item>
              <el-menu-item index="/tutorial">Tutorial</el-menu-item>
              <!-- <el-menu-item index="/data-introduction">Data introduction</el-menu-item> -->
            </el-submenu>

            <!-- <el-menu-item index="/help">Help</el-menu-item> -->
          </el-menu>
        </div>
      </el-col>

      <el-col :span="9" :pull="1">

        <!-- <div style="float: right; margin-right: 30px;">
          <div v-if="!isLogin">
            <el-button type="login" @click="login">Login</el-button>
            /
            <el-button type="login" >Register</el-button>
          </div>

          <div v-if="isLogin">
            Welcom, {{ firstName }} /
            <el-button type="login" @click="logout">Logout</el-button>
          </div>
        </div> -->

        <div style="float: right; " class="top-menu">
          <div class="login-menu">
            <el-menu
              v-if="!isLogin"
              mode="horizontal"
              >
              <el-menu-item index="1" @click="login">Login</el-menu-item>
              <el-menu-item index="2" @click="register">Register</el-menu-item>
            </el-menu>

            <el-menu
              v-if="isLogin"
              mode="horizontal"
              >
              <el-submenu index="3">
                <template slot="title">Welcome! {{ name }}</template>
                <el-menu-item @click="userProfile">User Profile</el-menu-item>
                <el-menu-item @click="logout">Logout</el-menu-item>
              </el-submenu>
            </el-menu>
          </div>
        </div>

      </el-col>
    </el-row>

  </div>
</template>

<script>
import { getLoginInfo } from '@/api'
import { removeToken, getToken, login, logout, register, userProfile } from '@/utils/auth'

export default {
  name: 'TopMenu',
  data () {
    return {
      isLogin: 0,
      loginEmail: '',
      name: ''
    }
  },

  // 默认激活
  computed: {
    // 使用计算属性来获取到当前点击的菜单的路由路径，设置default-active
    // 使得菜单在载入时就能对应高亮
    activeIndex: {
      get: function () {
        return this.$route.path
        // if (this.$route.path === '/request-new' || this.$route.path === '/request-view') {
        //   return 'request'
        // } else {
        //   return this.$route.path
        // }
      },
      set: function () {}
    }
  },

  methods: {
    toHome () {
      this.$router.push('/home')
    },

    // 跳转路由
    handleSelect (key, keyPath) {
      // console.log(key, keyPath)
      this.activeIndex = keyPath
    },

    login () {
      login()
    },
    logout () {
      logout()
    },

    register () {
      register()
    },

    userProfile () {
      userProfile()
    },

    async getLoginInfo () {
      if (getToken()) {
        // console.log('有 token!')
        const data = await getLoginInfo()
        // console.log(data)
        if (data.success) {
          var resp = data.data
          this.isLogin = 1
          this.name = resp.firstName + resp.lastName
        }
      }
      // else {
      //   console.log('没 token!')
      // }
    }

    // 从 SSO 系统获取 email
    // async getLoginEmail () {
    //   if (getToken()) {
    //     console.log('有 token!')
    //     const data = await getLoginEmail()
    //     console.log(data)
    //     if (data.success) {
    //       this.loginEmail = data.data
    //       this.getUserInfo()
    //     }
    //   } else {
    //     console.log('没 token!')
    //   }
    // },

    // 从数据库获取所有用户信息
    // async getUserInfo () {
    //   let params = {
    //     email: this.loginEmail
    //   }
    //   const data = await getUserInfo(params)
    //   // console.log(data)
    //   if (data.success) {
    //     var resp = data.data
    //     this.isLogin = 1
    //     this.firstName = resp.firstName
    //   }
    // }

  },

  mounted () {
    this.getLoginInfo()
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/general/TopMenu.vue